import { Component } from '@angular/core';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { AccountCenterService } from '../../../../../../coverpath-common/angular/services/account-center/account-center.service';
import { ModalService } from '../../../../../../coverpath-common/angular/services/modal/modal.service';
import { BasePolicyBannerComponent } from '../../../../../../coverpath-common/angular/components/account-center/policy-banner/base-policy-banner.component';
import {MMDirectPolicyStatus} from '../policy-status/policy-status';
import { MMDirectPolicy } from '../../../../../../coverpath-common/classes/mmdirect_subclasses/MMDirectPolicy';
import { ToastService } from '../../../../../../coverpath-common/angular/components/overlays/toaster/toast-service.service';
@Component({
    selector: 'policy-banner',
    moduleId: module.id,
    templateUrl: './policy-banner.component.html'
})
export class PolicyBannerComponent extends BasePolicyBannerComponent {
    showLifeBridgeFinancialsBanner: boolean;
    lifeBridgeSendDocumentToName: string;
    lifeBridgeSendDocumentToEmail: string;

    async ngOnInit(): Promise<void> {
        this.subscribeToAccountCenterService();
        this.isLoading = false;
        await this.setAllProperties();
        this.isLoading = false;
    }

    constructor(amorphicService: AmorphicService, accountCenterService: AccountCenterService, private modalService: ModalService, private toastService: ToastService) {
        super(amorphicService, accountCenterService, modalService, toastService);
        this.policyStatus = new MMDirectPolicyStatus(this.amorphicService, this.amorphicService.controller.customer.application.primaryPolicy as MMDirectPolicy, accountCenterService);
    }

    async setAllProperties(): Promise<void> {
        await super.setAllProperties();
        this.showLifeBridgeFinancialsBanner = this.policy.amorphicGetClassName() === 'LifeBridgePolicy';
        const channelCode = 'lifebridge';
        this.lifeBridgeSendDocumentToName = this.amorphicService.controller.amorphic.config.nconf.get('lifeBridgeOwnerName');
        this.lifeBridgeSendDocumentToEmail = this.amorphicService.controller.amorphic.config.nconf.get('lifeBridgeOwnerEmail');
    }
}
